import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

const breadStyles =
  ({ theme }) => css`
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    padding: 0 ${theme.spacings.mega};
  `

const Breadcrumb = styled('div')(breadStyles)

export const itemStyles =
  ({ theme }) => css`
    display: inline-block;
    font-size: 14px;
    color: ${theme.colors.n800};

    &:after {
      color: currentColor;
    }

    &:not(:last-child) {
      margin-right: ${theme.spacings.giga};
      color: ${theme.colors.p500};

      &:after {
        content: '|';
        position: relative;
        top: -2px;
        left: 12px;
        display: inline-block;
        color: ${theme.colors.n800};
      }
    }

    ${theme.media.mega} {
      margin-right: ${theme.spacings.tera};
      font-size: 16px;
    }
  `

const Item = styled('div')(itemStyles)

Breadcrumb.propTypes = {
  children: PropTypes.node.isRequired
}

Item.propTypes = {
  children: PropTypes.node.isRequired
}

Breadcrumb.Item = Item

export default Breadcrumb
